"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResponseContainsProperty = void 0;
const utils_1 = require("../../utils");
const ResponseContainsProperty = (options) => {
    const names = options.names || {};
    let key;
    return {
        Operation: {
            Response: {
                skip: (_response, key) => {
                    return `${key}` === '204';
                },
                enter: (_response, ctx) => {
                    key = ctx.key;
                },
                MediaType: {
                    Schema(schema, { report, location }) {
                        var _a;
                        if (schema.type !== 'object')
                            return;
                        const expectedProperties = names[key] ||
                            names[utils_1.getMatchingStatusCodeRange(key)] ||
                            names[utils_1.getMatchingStatusCodeRange(key).toLowerCase()] ||
                            [];
                        for (const expectedProperty of expectedProperties) {
                            if (!((_a = schema.properties) === null || _a === void 0 ? void 0 : _a[expectedProperty])) {
                                report({
                                    message: `Response object must contain a top-level "${expectedProperty}" property.`,
                                    location: location.child('properties').key(),
                                });
                            }
                        }
                    },
                },
            },
        },
    };
};
exports.ResponseContainsProperty = ResponseContainsProperty;
